"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSNSEvent = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const getSNSEvent = ({ payload, eventParams }) => {
    const messageAttributes = eventParams.messageAttributesObject ?? {};
    const template = {
        Records: [
            {
                EventSource: 'aws:sns',
                EventVersion: '1.0',
                EventSubscriptionArn: 'bbb',
                Sns: {
                    Type: 'Notification',
                    MessageId: 'aaa',
                    TopicArn: eventParams.topicArn ?? 'arn:aws:sns:mockRegion:mockAccountId:mockTopic',
                    Subject: eventParams.subject ?? 'mockSubject',
                    Message: '',
                    Timestamp: '',
                    SignatureVersion: '1',
                    Signature: '',
                    SigningCertURL: '',
                    UnsubscribeURL: '',
                    MessageAttributes: eventParams.messageAttributesObject
                        ? (0, iotv_v3_types_1.IOTV_SNS_MOCK_OUTPUT_ObjectToMessageAttributeMap)(messageAttributes)
                        : {
                            sk: {
                                Type: 'String',
                                Value: 'Something:ABC123_latestShadowState',
                            },
                            eventName: {
                                Type: 'String',
                                Value: 'MODIFY',
                            },
                            pk: {
                                Type: 'String',
                                Value: 'Something:ABC123',
                            },
                            type: {
                                Type: 'String',
                                Value: 'ThingShadowState',
                            },
                        },
                },
            },
        ],
    };
    template.Records[0].Sns.Message = JSON.stringify(payload);
    return template;
};
exports.getSNSEvent = getSNSEvent;
